import { Box, Button, Checkbox, createTheme, Dialog, DialogActions, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, ThemeProvider } from '@mui/material';

import { DialogTitle, Typography, withStyles } from '@material-ui/core';

import { withRouter } from 'react-router-dom';

import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import Spinner from 'modules/common/spinner.component';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { getClients, postClient, postClientDivision } from './clients.actions';
import { GET_CLIENTS_FAILURE, POST_CLIENT_SUCCESS, POST_CLIENT_DIVISION_FAILURE } from './types';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  }
});

const CreateClientDialog = props => {
  const { clientStatusTypes, industries } = props;

  const theme = createTheme({
    palette: {
        primary: COLOR_PRIMARY,
        secondary: COLOR_SECONDARY,
        warning: COLOR_WARNING
    }
  });

  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isSubmittable, setIsSubmittable] = useState(false);

  // Main client fields
//   const [clientId, setClientId] = useState(null);
//   const [clientCode, setClientCode] = useState(null);
  const [shortName, setShortName] = useState('');
  const [legalName, setLegalName] = useState('');
  const [clientStatusId, setClientStatusId] = useState('00000-0000-0000-0000-000000000000');
  const [dunnBradstreetNumber, setDunnBradstreetNumber] = useState('');
  const [isERCMember, setIsERCMember] = useState(false);
  const [industryId, setIndustryId] = useState('00000-0000-0000-0000-000000000000');
  const [fax, setFax] = useState('');
  const [phone, setPhone] = useState('');
  const [website, setWebsite] = useState('');
  const [previousProvider, setPreviousProvider] = useState('');

  const createClient = async () => {
    setIsLoadingModal(true);

    const clientInfo = {
        // clientId: clientId,
        // clientCode: clientCode,
        shortName: shortName,
        legalName: legalName,
        clientStatusId: clientStatusId,
        dunnBradstreetNumber: dunnBradstreetNumber,
        isERCMember: isERCMember,
        industryId: industryId,
        fax: fax,
        phone: phone,
        website: website,
        previousProvider: previousProvider,
        contractStartDate: null,
        contractEndDate: null,
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date()
    }

    const postClientResp = await props.postClient(clientInfo);
    if (postClientResp.type === POST_CLIENT_SUCCESS) {
        // Create default division for the newly created client
        const newClientRecordId = postClientResp.response.clientDetails.clientRecordId;
        const defaultDivision = {
            clientRecordId: newClientRecordId,
            divisionName: 'Default Division',
            divisionCode: Math.floor(Math.random() * 1000000).toString(),
            divisionKey: Math.floor(Math.random() * 1000000).toString(),
            addedOn: new Date(),
            addedBy: 1,
            modifiedOn: new Date(),
            modifiedBy: 1
        };

        const postDivisionResp = await props.postClientDivision(defaultDivision);
        if (postDivisionResp.type === POST_CLIENT_DIVISION_FAILURE) {
            props.showToast('Client created but failed to create default division.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }

        const getClientsResp = await props.getClients();
        if (getClientsResp.type !== GET_CLIENTS_FAILURE) {
            props.showToast('Successfully created new client!', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
            props.onCancel();
        } else {
            props.showToast('Failed to get client list, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });  
        }
    } else {
      props.showToast('Failed to create client, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }

    setIsLoadingModal(false);
  }

  useEffect(() => {
    if (shortName.length !== 0 && legalName.length !== 0 && dunnBradstreetNumber.length !== 0 &&
        phone.length !== 0 && clientStatusId !== '00000-0000-0000-0000-000000000000' && industryId !== '00000-0000-0000-0000-000000000000') {
            setIsSubmittable(true);
    } else {
        setIsSubmittable(false);
    }
  }, [shortName, legalName, dunnBradstreetNumber, phone, clientStatusId, industryId]);

  return (
    <ThemeProvider theme={theme}>
        <Dialog open={props.open} fullWidth={false} maxWidth={'lg'}>
            <DialogTitle>New Client</DialogTitle>
            <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
                {/* <Box>
                    <TextField
                      key={'clientId'}
                      label={'Acumatica Vendor Id'}
                      name={'clientId'}
                      required={true}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={clientId}
                      onChange={(e) => setClientId(e.target.value)}
                      type="number"
                      InputLabelProps={{ shrink: true }}
                    />
                    <Typography variant="caption" display="block" color="primary">
                      Required
                    </Typography>
                </Box> */}
                {/* <Box>
                    <TextField
                        key={'clientCode'}
                        label={'Client Code'}
                        name={'clientCode'}
                        value={clientCode}
                        variant="outlined"
                        required={true}
                        sx={{ maxWidth: '360px' }}
                        type="number"
                        onChange={(e) => setClientCode(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Typography variant="caption" display="block" color="primary">
                      Required
                    </Typography>
                </Box> */}
                <Box>
                    <TextField
                        key={'shortName'}
                        label={'Short Name'}
                        name={'shortName'}
                        value={shortName}
                        variant="outlined"
                        required={true}
                        sx={{ maxWidth: '360px' }}
                        type="text"
                        onChange={(e) => setShortName(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Typography variant="caption" display="block" color="primary">
                      Required
                    </Typography>
                </Box>
                <Box>
                    <TextField
                        key={'legalName'}
                        label={'Legal Name'}
                        name={'legalName'}
                        value={legalName}
                        variant="outlined"
                        required={true}
                        sx={{ maxWidth: '360px' }}
                        type="text"
                        onChange={(e) => setLegalName(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Typography variant="caption" display="block" color="primary">
                      Required
                    </Typography>
                </Box>
                <Box>
                    <TextField
                        key={'dunnBradstreetNumber'}
                        label={'Dunn Bradstreet Number'}
                        name={'dunnBradstreetNumber'}
                        value={dunnBradstreetNumber}
                        variant="outlined"
                        required={true}
                        sx={{ maxWidth: '360px' }}
                        type="text"
                        onChange={(e) => setDunnBradstreetNumber(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Typography variant="caption" display="block" color="primary">
                      Required
                    </Typography>
                </Box>
                <Box>
                    <TextField
                        key={'fax'}
                        label={'Fax'}
                        name={'fax'}
                        value={fax}
                        variant="outlined"
                        sx={{ maxWidth: '360px' }}
                        type="text"
                        onChange={(e) => setFax(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box>
                    <TextField
                        key={'phone'}
                        label={'Phone'}
                        name={'phone'}
                        value={phone}
                        variant="outlined"
                        required={true}
                        sx={{ maxWidth: '360px' }}
                        type="text"
                        onChange={(e) => setPhone(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Typography variant="caption" display="block" color="primary">
                      Required
                    </Typography>
                </Box>
                <Box>
                    <TextField
                        key={'website'}
                        label={'Website'}
                        name={'website'}
                        value={website}
                        variant="outlined"
                        sx={{ maxWidth: '360px' }}
                        type="text"
                        onChange={(e) => setWebsite(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box>
                    <TextField
                        key={'previousProvider'}
                        label={'Previous Provider'}
                        name={'previousProvider'}
                        value={previousProvider}
                        variant="outlined"
                        sx={{ maxWidth: '360px' }}
                        type="text"
                        onChange={(e) => setPreviousProvider(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Client Status
                        </InputLabel>
                        <Select
                            labelId={'clientStatusId'}
                            key={'clientStatusId'}
                            label={'clientStatusId'}
                            name={'clientStatusId'}
                            required={true}
                            disabled={false}
                            value={clientStatusId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setClientStatusId(e.target.value)}
                        >
                            {clientStatusTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'industryId'}>
                            Industry ID
                        </InputLabel>
                        <Select
                            labelId={'industryId'}
                            key={'industryId'}
                            label={'industryId'}
                            name={'industryId'}
                            required={true}
                            disabled={false}
                            value={industryId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setIndustryId(e.target.value)}
                        >
                            {industries.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                        <FormControlLabel
                            key={'isERCMember'}
                            name={'isERCMember'}
                            label={'Is ERC Member'}
                            labelPlacement="start"
                            control={<Checkbox />}
                            required={false}
                            disabled={false}
                            checked={isERCMember}
                            variant="standard"
                            margin="dense"
                            sx={{ marginTop: '6px', minWidth: '120px', maxWidth: '360px' }}
                            onClick={(e) => setIsERCMember(e.target.checked ? true : false)}
                        />
                    </FormControl>
                </Box>
            </Box>

            <DialogActions sx={{ p: '1.25rem' }}>
                {isLoadingModal && <Spinner />}
                {!isLoadingModal && (
                    <>
                        <Button onClick={() => props.onCancel()}>Cancel</Button>
                        <Button
                            onClick={createClient}
                            color="primary"
                            type="submit"
                            variant="contained"
                            disabled={!isSubmittable}
                        >
                            Create Client
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  const { countries, provinces, addressTypes, clientStatusTypes, industries } = state.enumerations.allEnums;
  
  return {
    countriesEnum: countries,
    provincesEnum: provinces,
    addressTypes: addressTypes,
    clientStatusTypes: clientStatusTypes,
    industries: industries
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    postClient,
    getClients,
    showToast,
    postClientDivision
  }),
)(CreateClientDialog);
